export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="18" fill="#FF6B00" />
    <path d="M20 22h24M20 31h24M30 22c8 0 8 9 0 9h-6l14 13" fill="none" stroke="#0B1120" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="48" cy="48" r="5" fill="#10B981" stroke="#0B1120" strokeWidth="3" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark />
    <span className="font-display text-lg font-bold leading-none tracking-tight text-white">
      Indian<span className="text-saffron">Pay</span>Hub
    </span>
  </span>
);
